/**
 * contains the abi and contract address
*/

class GuildPresetsContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			}
		],
		"name": "favoritePreset",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "instrumentType",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "newPreset",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[4]",
				"name": "tags",
				"type": "bytes32[4]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "tagPreset",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildsContractAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32[9]",
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"indexed": false,
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "NewPreset",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "PresetSample",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "PresetTagged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			}
		],
		"name": "PresetFavorited",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "instrumentType",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "PresetInstrumentType",
		"type": "event"
	}
        ]; 

        this.contractAddress = '0x45aC8aCbEba84071D4e549d4dCd273E01E5a8daF';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildPresetsContract;
